import { FormHelperText, SxProps } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import { NativeSelectInputProps } from '@mui/material/NativeSelect/NativeSelectInput';
import Box from '@mui/system/Box';
import { SelectOption } from 'common/types/select-option';
import React from 'react';

export interface WsNativeSelectProps {
  id: string;
  width: number;
  sx?: SxProps;
  fsx?: SxProps;
  value?: string;
  data: SelectOption[];
  // inputProps?: Partial<NativeSelectInputProps>;
  error?: boolean;
  disabled?: boolean;
  helperText?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const WsNativeSelect = ({ disabled = false, ...props }: WsNativeSelectProps) => {
  return (
    <FormControl
      sx={{
        minHeight: '47px',
        width: `${props.width}px`,
        ...props.fsx,
      }}
      error={props.error}
    >
      <NativeSelect
        value={props.value}
        onBlur={props.onBlur}
        onChange={props.onChange}
        error={props.error}
        disabled={disabled}
        inputProps={{
          name: props.id,
          id: props.id,
        }}
        sx={{
          ...props.sx,
        }}
      >
        {props.data &&
          props.data.map(x => (
            <option key={`${props.id}:${x.id}`} value={x.id}>
              {x.label}
            </option>
          ))}
      </NativeSelect>
      <FormHelperText
        sx={{
          marginLeft: 0,
        }}
      >
        {props.helperText}
      </FormHelperText>
    </FormControl>
  );
};
